import { Component, Input } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { Bind } from 'primeng/bind';
import { Card } from 'primeng/card';

@Component({
    selector: 'app-opening-hours',
    templateUrl: './opening-hours.component.html',
    styleUrl: './opening-hours.component.scss',
    imports: [TranslocoDirective, NgFor, Bind, Card, NgIf, NgClass]
})
export class OpeningHoursComponent {
  @Input() openingHours: any[] = [];
  days: string[] = [];

  constructor(private translocoService: TranslocoService) {
    this.translocoService.selectTranslateObject('days').subscribe(days => {
      this.days = days;
    });
  }
}
